import { css, SerializedStyles } from '@emotion/core'
import parse from 'html-react-parser'
import * as React from 'react'

import SignIcon from '../components/SignIcon'
import { breakpoints } from '../constants/breakPoints'
import { Button } from './Button'

interface ListBlockProps {
  title?: string
  description?: string
  iconType?: 'checkmark' | 'cross' | 'warning'
  listItems: string[]
  className?: string
  listColumns?: number
  listClassName?: string
  buttonText?: string
  buttonLink?: string
  center?: boolean
  cssStyle?: SerializedStyles
}

export const ListBlock: React.FunctionComponent<ListBlockProps> = ({
  title,
  description,
  iconType = 'checkmark',
  listItems,
  className,
  listColumns = 1,
  listClassName,
  buttonText,
  buttonLink,
  center = false,
  cssStyle,
}) => {
  return (
    <div css={cssStyle} className={className}>
      {title && <h3 className="heading3">{parse(title)}</h3>}
      {description && <div className={listClassName || 'body-1'}>{parse(description)}</div>}
      <ul className={listClassName || 'body-1'} css={listStyle(listColumns, center)}>
        {listItems.map((item, index) => (
          <div key={`${title}-list-item${index}`}>
            <li>
              <SignIcon type={iconType} /> {parse(item)}
            </li>
          </div>
        ))}
      </ul>
      {buttonText && buttonLink && (
        <Button link={buttonLink} css={buttonStyle}>
          {buttonText}
        </Button>
      )}
    </div>
  )
}

const listStyle = (listColumns: number, center: boolean) => css`
  list-style: none;
  text-align: left;

  ${center &&
  `
    display: flex;
    flex-direction: column;
    align-items: center;
  `}

  @media screen and (min-width: ${breakpoints.small + 1}px) {
    ${listColumns &&
    `
        columns: ${listColumns};
        -webkit-columns: ${listColumns};
        -moz-columns: ${listColumns};
    `};
  }

  li {
    display: grid;
    grid-template-columns: min-content auto;
    margin-bottom: 0.75rem;

    svg {
      margin-right: 0.5rem;
    }
  }

  @media screen and (max-width: ${breakpoints.small}px) {
    svg {
      margin-top: 2px;
    }
  }
`

const buttonStyle = css`
  margin-top: 0.5rem;
`
